import service from '@/utils/request'

export const useUserInfoApi = () => {
	return service.get('/sys/user/info')
}

export const useUserInfoSubmitApi = (dataForm: any) => {
	return service.put('/sys/user/info', dataForm)
}

export const useUserAvatarApi = (dataForm: any) => {
	return service.put('/sys/user/avatar', dataForm)
}

export const updatePasswordApi = (data: any) => {
	return service.put('/sys/user/password', data)
}

export const updatePasswordWithTokenApi = (data: any, token: string) => {
	return service.put('/sys/user/password', data, {
		headers: {
			Authorization: token
		}
	})
}

export const useUserApi = (id: number) => {
	return service.get('/sys/user/' + id)
}

export const useRealNameListApi = (idList: number[]) => {
	return service.post('/sys/user/nameList', idList)
}

export const usePhoneListApi = (idList: number[]) => {
	return service.post('/sys/user/phoneList', idList)
}

export const useUserSubmitApi = (dataForm: any) => {
	if (dataForm.id) {
		return service.put('/sys/user', dataForm)
	} else {
		return service.post('/sys/user', dataForm)
	}
}
